module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-behavior-7db5577fe74c3b78c70f88857e97b27d.svg";